"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
var Action = /** @class */ (function () {
    function Action(type, data) {
        this.type = type;
        this.data = data;
    }
    return Action;
}());
exports.Action = Action;
//# sourceMappingURL=Action.js.map